/**
 * ユーザ
 */
export class User {
    /** ユーザID */
    userId = ""
    /** 姓 */
    lastName = ""
    /** 名 */
    firstName = ""
    /** メールアドレス */
    mail = ""
    /** 部門コード */
    departmentCode = ""
    /** 部署コード */
    sectionCode = ""
    /** 非暗号化パスワード */
    plainPassword = ""

    /* 権限 */
    roleCodes: string[] = []

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<User>) {
        Object.assign(this, init)
    }

    /**
     * ユーザ名を取得する
     */
    get userName() {
        return (this.lastName + " " + this.firstName).trim()
    }
}
